module.exports = __webpack_public_path__ + "static/img/8.099edc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/8.png
// module id = wP2T
// module chunks = 0